<template>
  <layout-view>
    <template v-slot:content> 
      <v-btn
        @click="$emit('visit-plans-load');"
        color="grey lighten-3" depressed small class="mt-5 ml-5 mb-5"
        :loading="visitPlanLoadState.isLoading||loadState.isLoading"
    >
      Обновить список <v-icon small>mdi-refresh</v-icon>
    </v-btn>
      <v-list class="pa-0" v-if="loadState.isSuccess">
         <v-list-item
             v-for="(visitPlan, k) in visitPlans" :key="'visitPlan'+k"
             @click="visitPlanState.modalOpen(visitPlan);visitPlanId = visitPlan.id">
           <v-list-item-content>
             <v-list-item-title>
               <div class="font-weight-medium mb-1">
                 {{visitPlan.user.lastName=== null ? '': visitPlan.user.lastName}}
                 {{visitPlan.user.firstName=== null ? '': visitPlan.user.firstName}}
                 {{visitPlan.user.secondName=== null ? '': visitPlan.user.secondName}}
               </div>
               <div class="caption mb-1">К специалисту{{visitPlan.isLiveList ? '': ' '+$tools.date(visitPlan.begin)}}:</div>
               <v-row v-if="visitPlan.userSpec!==null" no-gutters class="align-center">
                 <v-col cols="auto">
                   <v-avatar class="user" size="32">
                     <img :src="visitPlan.userSpec.user.imageUrl" v-if="visitPlan.userSpec.user.imageUrl" alt="">
                   </v-avatar>
                 </v-col>
                 <v-col class="pl-2">
                   <div class="font-weight-medium">
                     {{visitPlan.userSpec.user.lastName=== null ? '': visitPlan.userSpec.user.lastName}}
                     {{visitPlan.userSpec.user.firstName=== null ? '': visitPlan.userSpec.user.firstName}}
                     {{visitPlan.userSpec.user.secondName=== null ? '': visitPlan.userSpec.user.secondName}}
                   </div>
                   <div class="caption text-wrap">
                     {{visitPlan.userSpec.spec.name}}
                     <v-icon small>mdi-chevron-left</v-icon>
                     {{visitPlan.userSpec.comDiv.comBranch.name}}
                     <div v-if="!$tools.isEmpty(visitPlan.userSpec.commentAdmin)" class="caption">
                       <v-icon class="mr-1" small>mdi-comment-text-outline</v-icon>
                       {{visitPlan.userSpec.commentAdmin}}
                     </div>
                   </div>
                 </v-col>
               </v-row>
               <div v-else class="font-weight-medium">
                 {{visitPlan.spec.name}}
               </div>
               <div v-if="!$tools.isEmpty(visitPlan.comment)" class="mt-1">
                 <div class="caption">Комментарий:</div>
                 <div class="caption">{{visitPlan.comment}}</div>
               </div>
             </v-list-item-title>
           </v-list-item-content>
         </v-list-item>
       </v-list>
       
       <visit-plan
          :state="visitPlanState"
          :usersSpecs="usersSpecs"
          @cancel="visitPlanState.modalClose()"
          @createdUpdatedDeleted="visitPlanState.modalClose();"
          @visitCreate="visitCreate();visitPlanState.modalClose();"
      />
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import LayoutView from "@/components/LayoutView.vue";
import VisitPlan from "@/views/Visit/VisitPlan";
import {
  Entity_UserSpec, 
  Entity_User, 
  Entity_Spec, 
  Entity_ComDiv,
  Entity_ComBranch,
} from "../../../../EntityStoreCacheService";

export default {
  components: {VisitPlan, LayoutView},
  props: ['visitPlans','visitPlanLoadState'],
  data: () => ({
    visitPlanState: new State(),
    loadState: new State(),
    visitPlanId:null,
    usersSpecs: [],
    storageHandler:null,
  }),
  mounted(){
    this.storageHandler = (event) => {
      console.log(event.key)
      if (event.key === 'visitFromVisitPlan') {
        this.$emit('visit-plans-load');
        localStorage.removeItem('visitFromVisitPlan');
      }
    }   
    window.addEventListener('storage', this.storageHandler)
    this.load();
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.storageHandler)
  },
  methods:{
    load(){
      new Entity_User()
      .selects([Entity_User.id].join('.'))
      .selects([Entity_User.firstName].join('.'))
      .selects([Entity_User.lastName].join('.'))
      .selects([Entity_User.secondName].join('.'))
      .selects([Entity_User.imageUrl].join('.'))
      .selects([Entity_User.type].join('.'))

      // .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.userSpecs, Entity_UserSpec.id ].join('.'))
      // .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user, Entity_User.userSpecs, Entity_UserSpec.commentAdmin].join('.'))
      
      .selects([Entity_User.userSpecs, Entity_UserSpec.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.color ].join('.'))

      .selects([Entity_User.userSpecs, Entity_UserSpec.commentAdmin ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.id ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.name ].join('.'))
      .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch,Entity_ComBranch.color ].join('.'))
      .filterAnd([Entity_User.entity, Entity_User.type].join('.')+' =?','spec')
      .page(1).onPage(10000)
      .order(Entity_User.lastName,true)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((data)=>{
        this.usersSpecs = data.items
      }, (e)=>{
        console.error(e.response.data.message);
      });
    },
    visitCreate() {
      window.open('/panel/visit?userId='+this.$route.params.id+'&visitPlanId='+this.visitPlanId+'&type=visitPlan', '_blank');
    }
  },
}
</script>
